import React from "react";
import { IReportSlide } from "./ReprortContextTypes";

export const slideContext = React.createContext<IReportSlide>({});

export const useSlideContext = () => React.useContext(slideContext);

export default slideContext;
